/** Shape used when appending a new journey to a friend doc (currently only deepening-relationships). */
export function createDeepeningJourney(journeyId, journeyType = 'deepening-relationships') {
  return {
    id: journeyId,
    type: journeyType,
    startDate: new Date().toISOString(),
    status: 'active',
    progress: {
      week1: { completed: 0, total: 6 },
      week2: { completed: 0, total: 4 },
      week3: { completed: 0, total: 4 },
      week4: { completed: 0, total: 3 }
    },
    completedActivities: {
      week1: [],
      week2: [],
      week3: [],
      week4: []
    },
    /** Cached output from personalizeFriendshipJourney (Cloud Function). */
    personalization: null
  };
}

export function newDeepeningJourneyId(journeyType = 'deepening-relationships') {
  return `${journeyType}-${Date.now()}`;
}
